module.exports = __webpack_public_path__ + "img/16581276_S.04c25b62.png";